<template>
  <div class="common_index_container" v-loading="loading"></div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CommonIndex",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState(['columnList']),
  },
  watch: {
    columnList: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    init() {
      if (this.isNotEmptyList(this.columnList)) {
        let column = $.extend({}, this.columnList[0]);
        this.storeCommit('SET_CURR_COLUMN', column);
        if (column.doc_num === 1) {
          if (this.isNotEmpty(column.ex_url)) {
            window.open(column.ex_url);
            return;
          }
          this.$router.push({
            path: `/detail/${column.init_url}`,
          });
          return;
        }
        this.$router.push({
          path: `/page/${column.code}`,
        });
      }
      this.loading = false;
    },
  },
}
</script>

<style scoped lang="scss">
.common_index_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>